export default "__VITE_ASSET__CxR0Yx9Q__"